import { extractDateAndTimeFromTimestamp } from '../../shared/utilities.js';
import { useLanguage } from '../../context/LanguageContext.js';
import './DoseMarker.css';

const DoseMarker = ({ timestamp }) => {
  const { language } = useLanguage();
  const [, time] = extractDateAndTimeFromTimestamp(timestamp, language);
  return (
    <p className="dose-marker">K - {time}</p>
  );
}

export default DoseMarker;
